// utils/confirmAction.js
import Swal from 'sweetalert2';
import './confirmAction.css'; // pastikan path-nya benar

export const confirmAction = async ({
  title,
  text,
  confirmText = 'Ya',
  cancelText = 'Tidak',
}) => {
  const result = await Swal.fire({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    reverseButtons: true,
    customClass: {
      popup: 'custom-popup',
      title: 'custom-title',
      confirmButton: 'custom-confirm',
      cancelButton: 'custom-cancel',
    },
  });

  return result.isConfirmed;
};
